import './Dashboard.css';

import React from 'react';
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import ProfileHeader from "../components/ProfileHeader";
import PrepaidBagsMenu from "../components/PrepaidBagsMenu";

interface Props {

}

const Dashboard = ({}: Props) => {
    return (
        <div>
            <div className={"header_logoContainer"}>
                <HandicaddieLogo size={'lg'}/>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                <ProfileHeader />
                {/*<QuickActionButtonBar  />*/}
                <PrepaidBagsMenu />
            </div>
        </div>
    )
}

export default Dashboard;